<div class="drink-basket-card-container" [ngClass]="{ 'last-card': isLast }" *ngIf="drink">
    <div class="drink-basket-card">
        <div class="drink-basket-info">
            <p class="drink-basket-title" (click)="onDrinkClicked(); $event.stopPropagation()">{{ drink | fieldTranslate: 'title' }}</p>
            
            <!-- модификаторы -->
            <div class="drink-basket-modificators" *ngIf="modificators" (click)="onDrinkClicked(); $event.stopPropagation()">
                <div class="drink-basket-modificator">
                    <p class="lowercase-text">{{ modificators.active ? (modificators | titleTranslate) : 'added' | translate }}:</p>
                    <div *ngFor="let item of modificators.items">
                        <div *ngIf="item.count > 0 && item.price as value">
                            <span>{{ item.count }} · {{ item | titleTranslate }} ·</span>
                            <ng-container *ngIf="item.count * item.price | priceSeparator as separated">
                                <span class="drink-basket-modificator__whole">{{ separated.whole }}</span>
                                <span class="drink-basket-modificator__dot">{{ separated.separator }}</span>
                                <span class="drink-basket-modificator__fraction">{{ separated.fraction }}</span>
                                <span class="drink-basket-modificator__currency">{{ locale?.currency }}</span>
                              </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <p class="drink-basket-price" *ngIf="drink.price as value">
                <ng-container *ngIf="value | priceSeparator as separated">
                    <span class="drink-basket-price__whole">{{ separated.whole }}</span>
                    <span class="drink-basket-price__dot">{{ separated.separator }}</span>
                    <span class="drink-basket-price__fraction">{{ separated.fraction }}</span>
                    <span class="drink-basket-price__currency">{{ locale?.currency }}</span>
                </ng-container>
                <span class="drink-basket-variant" *ngIf="variant">{{ variant }}</span>
                <span class="drink-basket-size" *ngIf="drink.size">{{ localSize }} {{ locale?.units?.get(drink.unit) }}</span>
            </p>
            <!-- Аллергены: свои и выбранных добавок -->
            <app-allergen-pill class="allergen-row" [plain]="true" [max]="14"
              [allergens]="drink.allergens | allergensWithAddons: modificators"></app-allergen-pill>
            
            <!-- Блок управления количеством -->
            <div class="drink-basket-counter">
                <button class="counter-button-dec" (click)="decrement(); $event.stopPropagation()">−</button>
                <span class="drink-basket-counter__value">{{ drink.count }}</span>
                <button class="counter-button-inc" (click)="increment(); $event.stopPropagation()">+</button>
            </div>
        </div>
        <div class="drink-basket-image" (click)="onDrinkClicked(); $event.stopPropagation()" *ngIf="drink.image">
            <img [src]="imageSrc" alt="{{ drink | fieldTranslate: 'title' }}" />
        </div>
    </div>
</div>